export enum UnitOfTime {
  S = 'S',
  MIN = 'MIN',
  H = 'H',
  D = 'D',
  WK = 'WK',
  MO = 'MO',
  A = 'A',
}
